import store from "../store/store";
import {get} from "axios/index";

const OFFER_BY_PRICE_URL = 'https://api-public.fin.cian.ru/widgets/marketplace-offers/v0/offers/offersByPrice';

let priceCache;
let typeCache;
let subtypeCache;

export function refreshOffers(price, type, subtype) {
    priceCache = price || priceCache;
    typeCache = type || typeCache;
    subtypeCache = subtype || subtypeCache;
    return get(`${OFFER_BY_PRICE_URL}?price=${priceCache}&type=${typeCache}&subtype=${subtypeCache}`, {withCredentials: true})
        .then(r => r.data)
        .then(offers => {
            store.dispatch({
                type: 'GOT_OFFERS',
                offers
            });
            return offers;
        })
        .catch(error => {
            console.log(error)
        });
}
